import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const useFactsScreen = () => {
  const {
    FactsStore: {
      handleFetchMoleculeAndConceptDetailsByGfc,
      handleFetchNdcEditDropDownData,
    },
  } = useStore();
  const [gfcParam] = useSearchParamsState('gfc', '');

  useEffect(() => {
    handleFetchNdcEditDropDownData();
    if (gfcParam) {
      handleFetchMoleculeAndConceptDetailsByGfc(gfcParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run on mount only
  }, []);
  return { handleFetchNdcEditDropDownData };
};
